import React, { useEffect, useState } from "react";
import { Loader } from "@progress/kendo-react-indicators";
import "./SiteLoader.css";
import { useSelector, useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { setRunningUrlQuery, setUrlQuery } from "../redux/setConfigSlice";

const SiteLoader = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const paramsToLower = new URLSearchParams(
        [...searchParams].map(([key, value]) => [key.toLowerCase(), value])
    );
    const bypassParam = paramsToLower.get("bypassloading") ?? "false";
    const runningUrlQuery = useSelector((state) => state.configData.runningUrlQuery);
    const urlQuery = useSelector((state) => state.configData.urlQuery);
    const siteLoading = useSelector((state) => state.configData.siteLoading);

    if (urlQuery === undefined) {
        // Check for data query
        const isDataQuery = checkUrlForQuery(paramsToLower);
        if (isDataQuery) {
            dispatch(setRunningUrlQuery(true));
        }
        dispatch(setUrlQuery(isDataQuery));
    }
    // Check if loading should be bypassed
    function canShowLoading() {
        if (process.env.REACT_APP_LOADING_BYPASSABLE.toString() === "true") {
            if (bypassParam.toString() === "true") {
                return false;
            }
        }
        return true;
    }

    // If a query is being ran then make user wait till site loads
    return runningUrlQuery === true || (siteLoading && canShowLoading()) ? (
        <>
            <div className="loadingDiv">TESTING</div>
            <Loader size="large" type="infinite-spinner" />
        </>
    ) : null;
};

export default SiteLoader;

/**
 * @param {Object} paramsToLower URLSearchParams object in all lowercase
 * @returns {Object | False} Returns object with search params or false if no urlQuery
 */

const checkUrlForQuery = (paramsToLower) => {
    if (
        paramsToLower.has("searchlayer") &&
        paramsToLower.has("searchfield") &&
        paramsToLower.has("searchstring")
    ) {
        const queryData = {
            layer: paramsToLower.get("searchlayer"),
            field: paramsToLower.get("searchfield"),
            value: paramsToLower.get("searchstring"),
        };
        return queryData;
    } else {
        return false;
    }
};
